import styled from 'styled-components'

export const CatalogItemDetailsPriceStyled = styled.span`
  flex-shrink: 0;
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
  line-height: ${(props) => props.theme.typography.pxToRem(24)};
`
